export default __webpack_public_path__ + "static/638-0b476880505fb67ff1ea2850094f9647.gif";